import { categories } from '@/mocks/categories';

export default function CategoryCards() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Popularne Kategorie Produktów
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Przeglądaj wszystkie kategorie dostępne w Kakobuy Spreadsheet i znajdź produkty idealne dla siebie.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300/50 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative w-full aspect-square overflow-hidden bg-background-100">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  title={`Kakobuy Spreadsheet ${cat.name} - najlepsze produkty`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-3 md:p-4 text-center">
                <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-foreground-950 transition-colors">
                  {cat.name}
                </span>
                <span className="block text-xs text-foreground-400 mt-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
                  Zobacz produkty
                  <i className="ri-arrow-right-up-line text-[10px] ml-1"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}